import {
  RoadmapItemDto,
  RoadmapsClient,
} from "../../../../../customer-experience/src/lib/ShiOneClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../../../../../customer-experience/src/v2/src/utils";
import { CACHE_KEY_ROADMAPS_BY_ID } from "../utils/constants";

const useBulkCreateRoadmapItems = () => {
  const queryClient = useQueryClient();
  const api = useApi(RoadmapsClient);

  return useMutation({
    mutationFn: async (roadmapItems: RoadmapItemDto[]) => {
      return await api.bulkCreateRoadmapItems(roadmapItems);
    },
    onSettled: () => {
      queryClient
        .invalidateQueries({ queryKey: [CACHE_KEY_ROADMAPS_BY_ID] })
        .then();
    },
  });
};

export default useBulkCreateRoadmapItems;
